import Layout from 'Nori/Layout';
import Container from 'Nori/Container';
import styles from 'styles/pages/siteMaps.module.scss';
import FooterList from 'Custom/Footer/FooterList';

import {
  NAV_ITEMS_1,
  NAV_ITEMS_2,
  NAV_ITEMS_3,
  NAV_ITEMS_4,
  NAV_ITEMS_5,
} from 'Custom/Footer/Footer.utils.js';
import RichText from 'Custom/RichText/index';

const HEAD = {
  title: 'Site Map for NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Explore the site map for NEXPLANON® (etonogestrel implant) 68 mg Radiopaque to easily find information about insertion, effectiveness, side effects, cost, and more.',
  keywords:
    'Nexplanon Sitemap, Nexplanon Website Map, Nexplanon Resources, Nexplanon Pages',
};

export default function siteMap() {
  return (
    <Layout data-qa-tag="site-map" head={HEAD}>
      <div
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="Site map"
        data-design-module_no="01"
      >
        <Container>
          <RichText className={styles.title}>
            <h1 data-qa-tag="heading-site-map" className="h2">Site map</h1>
          </RichText>
        </Container>
        <Container className={styles.container}>
          <FooterList
            data-qa-tag="footer-list-1-site-map"
            designNoriId="Inline Content"
            designModuleName="Site map"
            designCategory="content_link_vd"
            designModuleNumber="01"
            {...NAV_ITEMS_1}
          />
          <FooterList
            data-qa-tag="footer-list-2-site-map"
            designNoriId="Inline Content"
            designModuleName="Site map"
            designCategory="content_link_vd"
            designModuleNumber="01"
            {...NAV_ITEMS_2}
          />
          <FooterList
            data-qa-tag="footer-list-3-site-map"
            designNoriId="Inline Content"
            designModuleName="Site map"
            designCategory="content_link_vd"
            designModuleNumber="01"
            {...NAV_ITEMS_3}
          />
          <div className={styles.columnContainer}>
            <FooterList
              data-qa-tag="footer-list-4-site-map"
              designNoriId="Inline Content"
              designModuleName="Site map"
              designCategory="content_link_vd"
              designModuleNumber="01"
              {...NAV_ITEMS_4}
            />
            <FooterList
              data-qa-tag="footer-list-5-site-map"
              designNoriId="Inline Content"
              data-design-nori_id="Inline Content"
              designCategory="content_link_vd"
              designModuleNumber="01"
              {...NAV_ITEMS_5}
            />
          </div>
        </Container>
      </div>
    </Layout>
  );
}
